import AppDispatcher from '../dispatcher/AppDispatcher';
import { EventEmitter } from 'events';
import TermsConditionApiUtils from '../utils/TermsConditionApiUtils';
import HelpConstants from '../constants/HelpConstants';
import AppConstants, { CHANGE_EVENT } from '../constants/AppConstants';
import UserManagementStore from './UserManagementStore';

let _TcData = '';
let _tandCversion = '';
let _tandCService = '';
let _showTC = false;
let _TCError = false;
let backUrl = '';

const HelpStore = Object.assign({}, EventEmitter.prototype, {
  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  getAll() {
    return _TcData || '';
  },
  getShowTC() {
    return _showTC;
  },

  getTCError() {
    return _TCError;
  },
  getBackUrl() {
    return backUrl;
  },
  resetStore() {
    backUrl = '';
    this.emitChange();
  },
});

HelpStore.dispatchToken = AppDispatcher.register((payload) => {
  const action = payload.action;
  switch (action.actionType) {
    case HelpConstants.GET_TC_DATA:
      _showTC = false;
      _TCError = false;
      TermsConditionApiUtils.getTcData(UserManagementStore.isSMEUser());
      HelpStore.emitChange();
      break;

    case HelpConstants.GET_TC_DATA_SUCCESS:
      _tandCversion = action.data.version;
      _tandCService = action.data.service;
      TermsConditionApiUtils.getTextUrl(
        UserManagementStore.isSMEUser(),
        action.data.content.ref
      );
      break;

    case HelpConstants.GET_TC_DATA_ERROR:
      _showTC = false;
      _TCError = true;
      HelpStore.emitChange();
      break;

    case HelpConstants.GET_TC_TEXT_DATA_SUCCESS:
      _showTC = true; // This gets true only when i get data from services. Otherwise it simply means data not available.
      _TCError = false;
      _TcData = action.data;
      HelpStore.emitChange();
      break;
    case HelpConstants.REQUEST_ACCEPT_TC:
      TermsConditionApiUtils.acceptedTermsAndConditions(
        _tandCService,
        _tandCversion
      );
      break;
    case HelpConstants.SET_BACK_URL:
      backUrl = action;
      break;
    case AppConstants.LOGOUT_USER:
      HelpStore.resetStore();
      HelpStore.emitChange();
      break;
    default:
  }
});

export default HelpStore;
